module.exports = __webpack_public_path__ + "static/img/bannerAb.9edcebc7.png";